import { render, staticRenderFns } from "./CopyValue.vue?vue&type=template&id=197cce8f&"
import script from "./CopyValue.vue?vue&type=script&lang=js&"
export * from "./CopyValue.vue?vue&type=script&lang=js&"
import style0 from "./CopyValue.vue?vue&type=style&index=0&id=197cce8f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports